unit unit_Rechnungen;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, WEBLib.Grids, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, strutils, XData.Web.Client, DB;

type
  TRechnungen = class(TForm)
    xdsRechnungen: TXDataWebDataSet;
    xdsRechnungenKundennummer: TXDataWebEntityField;
    xdsRechnungenNummerkomplett: TStringField;
    xdsRechnungenDatum: TDateTimeField;
    xdsRechnungenJahr: TFloatField;
    xdsRechnungenBruttosumme: TFloatField;
    xdsRechnungenAuftragsbezeichnung: TStringField;
    TC: TTableControl;
    WClient: TXDataWebClient;
    procedure WebFormShow(Sender: TObject);
    procedure xdsRechnungenAfterOpen(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    Belegnummer:string;
    mybuttonDetails:TButton;
    buttonzurueck:TButton;
    procedure buttonzurueckclick(Sender:TObject);
    procedure mybuttonDetailsclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  Rechnungen: TRechnungen;

implementation
  uses unit1, unit2, unit_EinzelBeleg;
{$R *.dfm}
procedure TRechnungen.mybuttonDetailsclick(Sender:TObject);
var
  EinzelBeleg:TEinzelBeleg;
    procedure AfterCreate(AForm:TObject);
    begin
      with sender as TButton do
      begin
        Belegnummer:=tc.Cells[0,tag];
        Belegnummer:=replacestr(Belegnummer,'<b>','');
        Belegnummer:=replacestr(Belegnummer,'</b>','');
      end;
      (AForm as TEinzelBeleg).Belegnummer:=Belegnummer;
      (AForm as TEinzelBeleg).Belegart:='Rechnungen';
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //nothing to do
    end;

  begin

  EinzelBeleg:=TEinzelBeleg.CreateNew(@AfterCreate);
  EinzelBeleg.ShowModal(@AfterShowmodal);

end;
procedure TRechnungen.buttonzurueckclick(Sender:TObject);
begin
  close;
end;



procedure TRechnungen.WebFormShow(Sender: TObject);
begin
  xdsRechnungen.Close;
  xdsRechnungen.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer)+'&$orderby=Nummerkomplett DESC' ;
  xdsRechnungen.Load;
end;

procedure TRechnungen.xdsRechnungenAfterOpen(DataSet: TDataSet);
var
  temptext:string;
  i:integer;
  myelement:TJSHTMLElement;
begin
  TC.ColCount:=5;
  tc.RowCount:=xdsRechnungen.RecordCount+3;
  TC.Cells[0,0]:='<h4>Rechnungen';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;

  inc(i);
  tc.Cells[0,i]:='<b>Rechnung-Nr.';
  tc.Cells[1,i]:='<b>Datum';
  tc.Cells[2,i]:='<b>Bezeichnung';
  tc.Cells[3,i]:='<b>Betrag';
  tc.Cells[4,i]:='<b>Download';
  xdsRechnungen.First;
  while not xdsRechnungen.eof do
  begin
    inc(i);
    tc.Cells[0,i]:='<b>'+xdsRechnungenNummerkomplett.AsString+'</b>';
    tc.Cells[1,i]:=formatdatetime('DD.MM.YYYY',xdsRechnungenDatum.AsDateTime);
    tc.Cells[2,i]:=xdsRechnungenAuftragsbezeichnung.AsString;
    tc.Cells[3,i]:='<p class="text-right">'+formatfloat('#,##0.00',xdsRechnungenBruttosumme.Asfloat);

    myelement:=TC.cellelements[4,i];
    mybuttonDetails:=TButton.Create(self);
    mybuttonDetails.ElementClassName:='btn btn-info text-left';
    mybuttonDetails.HeightStyle:=ssauto;
    mybuttonDetails.WidthStyle:=ssauto;
    mybuttonDetails.tag:=i;
    mybuttonDetails.Caption:='Details';
    mybuttonDetails.OnClick:=@mybuttonDetailsclick;
    mybuttonDetails.ParentElement:=myelement;
    xdsRechnungen.Next;
  end;

end;

procedure TRechnungen.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  xdsRechnungen := TXDataWebDataSet.Create(Self);
  xdsRechnungenKundennummer := TXDataWebEntityField.Create(Self);
  xdsRechnungenNummerkomplett := TStringField.Create(Self);
  xdsRechnungenDatum := TDateTimeField.Create(Self);
  xdsRechnungenJahr := TFloatField.Create(Self);
  xdsRechnungenAuftragsbezeichnung := TStringField.Create(Self);
  xdsRechnungenBruttosumme := TFloatField.Create(Self);
  WClient := TXDataWebClient.Create(Self);

  TC.BeforeLoadDFMValues;
  xdsRechnungen.BeforeLoadDFMValues;
  xdsRechnungenKundennummer.BeforeLoadDFMValues;
  xdsRechnungenNummerkomplett.BeforeLoadDFMValues;
  xdsRechnungenDatum.BeforeLoadDFMValues;
  xdsRechnungenJahr.BeforeLoadDFMValues;
  xdsRechnungenAuftragsbezeichnung.BeforeLoadDFMValues;
  xdsRechnungenBruttosumme.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  try
    Name := 'Rechnungen';
    Width := 182;
    Height := 236;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 153;
    TC.Height := 193;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    xdsRechnungen.SetParentComponent(Self);
    xdsRechnungen.Name := 'xdsRechnungen';
    xdsRechnungen.AfterOpen := xdsRechnungenAfterOpen;
    xdsRechnungen.EntitySetName := 'Rechnung';
    xdsRechnungen.Connection := DM2.XDataWebConnection1;
    xdsRechnungen.Left := 24;
    xdsRechnungen.Top := 16;
    xdsRechnungenKundennummer.SetParentComponent(xdsRechnungen);
    xdsRechnungenKundennummer.Name := 'xdsRechnungenKundennummer';
    xdsRechnungenKundennummer.FieldName := 'Kundennummer';
    xdsRechnungenKundennummer.Required := True;
    xdsRechnungenNummerkomplett.SetParentComponent(xdsRechnungen);
    xdsRechnungenNummerkomplett.Name := 'xdsRechnungenNummerkomplett';
    xdsRechnungenNummerkomplett.FieldName := 'Nummerkomplett';
    xdsRechnungenNummerkomplett.Required := True;
    xdsRechnungenNummerkomplett.Size := 10;
    xdsRechnungenDatum.SetParentComponent(xdsRechnungen);
    xdsRechnungenDatum.Name := 'xdsRechnungenDatum';
    xdsRechnungenDatum.FieldName := 'Datum';
    xdsRechnungenDatum.Required := True;
    xdsRechnungenJahr.SetParentComponent(xdsRechnungen);
    xdsRechnungenJahr.Name := 'xdsRechnungenJahr';
    xdsRechnungenJahr.FieldName := 'Jahr';
    xdsRechnungenAuftragsbezeichnung.SetParentComponent(xdsRechnungen);
    xdsRechnungenAuftragsbezeichnung.Name := 'xdsRechnungenAuftragsbezeichnung';
    xdsRechnungenAuftragsbezeichnung.FieldName := 'Auftragsbezeichnung';
    xdsRechnungenAuftragsbezeichnung.Size := 255;
    xdsRechnungenBruttosumme.SetParentComponent(xdsRechnungen);
    xdsRechnungenBruttosumme.Name := 'xdsRechnungenBruttosumme';
    xdsRechnungenBruttosumme.FieldName := 'Bruttosumme';
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := DM2.XDataWebConnection1;
    WClient.Left := 96;
    WClient.Top := 16;
  finally
    TC.AfterLoadDFMValues;
    xdsRechnungen.AfterLoadDFMValues;
    xdsRechnungenKundennummer.AfterLoadDFMValues;
    xdsRechnungenNummerkomplett.AfterLoadDFMValues;
    xdsRechnungenDatum.AfterLoadDFMValues;
    xdsRechnungenJahr.AfterLoadDFMValues;
    xdsRechnungenAuftragsbezeichnung.AfterLoadDFMValues;
    xdsRechnungenBruttosumme.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
  end;
end;

end.
